export enum ENUM_STATUS {
    ATIVO = 1,
    INATIVO = 2,
}

export enum ENUM_STATUS_PROJETO {
    RASCUNHO = 3,
    EM_ANDAMENTO = 4,
    CONCLUIDO = 5,
    CONCLUIDO_ATRASO = 6,
    CANCELADO = 7,
    EXCLUIDO = 14,
}

export enum ENUM_PAGES {
    painelKPI = 'painelKPI',
    painelProjetosTodos = 'painelProjetosTodos',
    painelGeorreferencia = 'painelGeorreferencia',
    cadastroGrupoFluxo = 'cadastroGrupoFluxo',
    cadastroProjetos = 'cadastroProjetos',
    cadastroSecretarias = 'cadastroSecretarias',
    cadastroPastas = 'cadastroPastas',
    cadastroTipoDeUsuario = 'cadastroTipoDeUsuario',
    cadastroTipoGrupoFluxo = 'cadastroTipoGrupoFluxo',
    gerenciamentoUsuario = 'gerenciamentoUsuario',
    acaoExcluirProjeto = 'acaoExcluirProjeto',
    acaoVerTodosProjetos = 'acaoVerTodosProjetos',
}

export enum ENUM_SEMAFORO_PROJETO {
    VERDE = 1,
    AMARELO = 2,
    VERMELHO = 3,
}

export enum ENUM_TIPO_VINCULO {
    DATA_INICIO = 1,
    CUSTOM = 2,
    FLUXO = 3,
}

export enum ENUM_STATUS_PROJETO_FLUXO {
    AGUARDANDO = 8,
    EM_ANDAMENTO = 9,
    CONCLUIDO = 10,
    CONCLUIDO_ATRASO = 11,
    CANCELADO = 12,
    ATRASADO = 13,
}

export enum ENUM_TIPO_LINK {
    IMAGEM = 1,
    VIDEO = 2,
    CAMERA = 3,
}

export enum ENUM_SCRUMBOARD {
    A_FAZER = 15,
    FAZENDO = 16,
    CONCLUIDO = 17,
    CANCELADO = 18,
  }